import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const HeroSection = ({ 
  title, 
  subtitle, 
  buttonText, 
  buttonLink, 
  backgroundImage, 
  showIllustration = true 
}) => {
  const sectionStyle = backgroundImage 
    ? { 
        ...styles.hero, 
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : styles.hero; // fallback to gradient defined in CSS

  return (
    <section className="hero" style={sectionStyle}>
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-title">{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>
          {buttonText && (
            <Link to={buttonLink} className="btn hero-btn">
              {buttonText}
            </Link>
          )}
        </div>
        {showIllustration && (
          <div className="hero-illustration">
            <div className="illustration-box">
              <div className="hero-animation">
                <div className="animated-element"></div>
                <div className="animated-element2"></div>
                <div className="animated-element3"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

// Inline styles for dynamic background – the rest is handled by CSS classes
const styles = {
  hero: {
    padding: '100px 0',
    color: 'white',
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
  }
};

export default HeroSection;